import { defineStyleConfig } from "@chakra-ui/react";

const Popover = defineStyleConfig({
  // The styles all button have in common
  baseStyle: {
    content: {
      bg: "secondary.700",
      color: "secondary.50",
    },
  },
});

export default Popover;
